import { MessageSquare, Eye, Zap, Search } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useEffect, useMemo } from 'react';

const colorClasses = {
  blue: 'bg-blue-100 text-blue-600',
  green: 'bg-green-100 text-green-600',
  orange: 'bg-orange-100 text-orange-600',
  teal: 'bg-teal-100 text-teal-600',
} as const;

export function Research() {
  const { t } = useLanguage();

  const researchAreas = useMemo(() => [
    {
      icon: MessageSquare,
      title: t('research_nlp'),
      description: t('research_nlp_desc'),
      color: 'blue' as const,
      image: '/assets/utopia.jpg',
    },
    {
      icon: Search,
      title: t('research_cv'),
      description: t('research_cv_desc'),
      color: 'green' as const,
      image: '/assets/education.png',
    },
    {
      icon: Zap,
      title: t('research_rl'),
      description: t('research_rl_desc'),
      color: 'orange' as const,
      image: '/assets/innovation.png',
    },
    {
      icon: Eye,
      title: t('research_xai'),
      description: t('research_xai_desc'),
      color: 'teal' as const,
      image: '/assets/howtocommunicatewithai.png',
    },
  ], [t]);


  return (
    <section id="research" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('research_title')}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('research_intro')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {researchAreas.map((area, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div
                    className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                      colorClasses[area.color as keyof typeof colorClasses]
                    }`}
                  >
                    <area.icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 ml-4">{area.title}</h3>
                </div>
                <div className="text-gray-600 leading-relaxed space-y-4">
                  {area.description.split('\n\n').map((paragraph, i) => (
                    <p key={i} className={i > 0 ? 'mt-4' : ''}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
